import { useNavigate } from "react-router-dom";
import logoEgam from "../../assets/images/logo-egam-login.png";
import {
  Container,
  Card,
  Logo,
  ErrorCode,
  Title,
  Subtitle,
  Button,
  Divider,
} from "./styles";

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 19l-7-7m0 0l7-7m-7 7h18"
    />
  </svg>
);

const NoMatch = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Card>
        <Logo src={logoEgam} alt="eGAM" />

        <ErrorCode>404</ErrorCode>

        <Title>Página não encontrada</Title>

        <Divider />

        <Subtitle>
          A página que você está procurando não existe ou foi movida para outro
          endereço.
        </Subtitle>

        <Button onClick={() => navigate(-1)}>
          <ArrowIcon />
          Voltar
        </Button>
      </Card>
    </Container>
  );
};

export default NoMatch;
